import { StrictMode } from 'react';
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';
import { createRoot } from 'react-dom/client';
import TagManager from 'react-gtm-module';
import { initialize, loadCookieConsentScript } from '@fff-web/fff-analytics';
import { getAccountInfo, UserProvider } from '@fff-web/fff-utilities';
import { receiveUserStatus } from './pages/MyAccount/services/actions/userActions';
import store from './pages/MyAccount/store';
import { bootstrapDatadog } from './utils/datadog';
import { getUUID } from './utils/Optimizely/experiments';
import './index.css';
import App from './App';

const tagManagerArgs = {
  gtmId: process.env.REACT_APP_GTM_CONTAINER_ID,
};

TagManager.initialize(tagManagerArgs);

initialize();
loadCookieConsentScript();
bootstrapDatadog();

globalThis.window.FFF = { ...globalThis.window.FFF };
globalThis.window.FFF[process.env.APP_NAME] = {
  version: process.env.APP_VERSION,
  libs: process.env.APP_LIBS,
};

const container = document.getElementById('root');
if (container !== null) {
  (async () => {
    let ldArgs;
    let id;

    try {
      const accountResponse = await getAccountInfo();
      const { userId, accountCode } = accountResponse;
      store.dispatch(receiveUserStatus(accountResponse));
      id = userId.toString();

      ldArgs = {
        clientSideID: process.env.REACT_APP_LD_CLIENT_ID,
        context: {
          kind: 'user',
          key: id,
          email: accountCode,
        },
        options: {
          useReport: true,
        },
      };
    } catch {
      ldArgs = { clientSideID: process.env.REACT_APP_LD_CLIENT_ID };
      id = getUUID();
    }

    const LDProvider = await asyncWithLDProvider(ldArgs);

    const root = createRoot(container!);
    root.render(
      <StrictMode>
        <LDProvider>
          <UserProvider>
            <App />
          </UserProvider>
        </LDProvider>
      </StrictMode>,
    );
  })();
}
